import {getOssOnlineImgFile} from "@/utils";
export const actStartTime = "2023-12-04 09:00:00"; //当前期数开始时间
export const actEndTime = "2024-12-26 23:59:59"; //当前期数结束时间
export const activityId = 19;

export const rewardList = [
  {
    imgUrl: getOssOnlineImgFile("openBlind/reward1.png"),
    name: "蒸烤炸一体机"
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/reward2.png"),
    name: "防滑铸铁炒锅"
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/reward3.png"),
    name: "厨房洗护套装"
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/reward4.png"),
    name: "厨源小布"
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/reward5.png"),
    name: "老板电器新年礼盒"
  }
]; //盲盒奖池
export const recipeList = [
  {
    name: "蜜汁烤鸡翅",
    id: 9003,
    currDeviceName: "一体机/电烤箱/灶蒸烤一体机",
    viewCount: 303304,
    imgCover169:
      "https://oss.myroki.com/recipe/cover/cover169/5kbi0UMxNCskeRCbXh90imageCover169w1920h1080.jpg"
  },
  {
    name: "戚风蛋糕",
    id: 560,
    currDeviceName: "一体机/电烤箱/集成灶/灶蒸烤一体机",
    viewCount: 178504,
    imgCover169:
      "http://roki.oss-cn-hangzhou.aliyuncs.com/recipe/cover/cover169/9db290d5-306b-4661-8a05-78c213260ce6.jpg"
  },
  {
    name: "迷迭香烤羊排",
    id: 497,
    currDeviceName: "一体机/电烤箱/集成灶/灶蒸烤一体机",
    viewCount: 236777,
    imgCover169:
      "https://oss.myroki.com/recipe/cover/cover169/EbFUXjrkVGIPsf4zSzwnimageCover169w1920h1080.jpg"
  },
  {
    name: "葡式蛋挞",
    id: 9026,
    currDeviceName: "一体机/电烤箱/集成灶/灶蒸烤一体机",
    viewCount: 123476,
    imgCover169:
      "http://roki.oss-cn-hangzhou.aliyuncs.com/recipe/cover/cover169/526ac1bc-1e11-4356-94b4-d618f8fab65c.jpg"
  },
  {
    name: "豆豉蒸鲈鱼",
    id: 9005,
    currDeviceName: "一体机/电蒸箱/灶蒸烤一体机",
    viewCount: 106000,
    imgCover169:
      "https://oss.myroki.com/recipe/cover/cover169/4W9ofuXYIQ1NLvTPlmiwimageCover169w1920h1080.jpg"
  },
  {
    name: "烤红薯",
    id: 13005,
    currDeviceName: "一体机/集成灶/灶蒸烤一体机",
    viewCount: 66140,
    imgCover169:
      "http://roki.oss-cn-hangzhou.aliyuncs.com/recipe/cover/cover169/41ec2112-a69d-497e-b123-ac3d6310f76bw1000h985.jpg"
  },
  {
    name: "鸡蛋羹",
    id: 9013,
    currDeviceName: "一体机/电蒸箱/灶蒸烤一体机/集成灶",
    viewCount: 110622,
    imgCover169:
      "https://oss.myroki.com/recipe/cover/cover169/8CuEPmIcKGWQc57GFibaimageCover169w1920h1080.jpg"
  },
  {
    name: "烤牛排",
    id: 9027,
    currDeviceName: "一体机/电烤箱/集成灶/灶蒸烤一体机",
    viewCount: 81233,
    imgCover169:
      "https://oss.myroki.com/recipe/cover/cover169/SUuHeWZEi6uOKTVNkWE6imageCover169w1920h1080.jpg"
  },
  {
    name: "蔓越莓饼干",
    id: 559,
    currDeviceName: "一体机/电烤箱/集成灶/灶蒸烤一体机",
    viewCount: 71583,
    imgCover169:
      "https://oss.myroki.com/recipe/cover/cover169/3HC6nfswRcO18e8cYKbNimageCover169w1920h1080.jpg"
  },
  {
    name: "果香烤鸡",
    id: 12980,
    currDeviceName: "一体机/电烤箱/集成灶/灶蒸烤一体机",
    viewCount: 36097,
    imgCover169:
      "https://oss.myroki.com/recipe/cover/cover169/QY7aoyznfDgo87IQsevTimageCover169w1920h1080.jpg"
  },
  {
    name: "重庆烤鱼",
    id: 12262,
    currDeviceName: "一体机/电烤箱/灶蒸烤一体机",
    viewCount: 39530,
    imgCover169:
      "https://oss.myroki.com/recipe/cover/cover169/pBlQB6haEPfX55joczZ5imageCover169w1920h1080.jpg"
  },
  {
    name: "豆豉蒸排骨",
    id: 532,
    currDeviceName: "一体机/电蒸箱/集成灶/灶蒸烤一体机",
    viewCount: 44241,
    imgCover169:
      "https://oss.myroki.com/recipe/cover/cover169/RztjGcCbvjjVuyppDL4AimageCover169w1920h1080.jpg"
  }
];
export const themeList = [
  {
    imgUrl: getOssOnlineImgFile("openBlind/topic6.png"),
    themeId: 275
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/topic7.png"),
    themeId: 274
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/topic8.png"),
    themeId: 272
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/topic9.png"),
    themeId: 271
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/topic1.png"),
    themeId: 270
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/topic2.png"),
    themeId: 269
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/topic3.png"),
    themeId: 268
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/topic4.png"),
    themeId: 267
  },
  {
    imgUrl: getOssOnlineImgFile("openBlind/topic5.png"),
    themeId: 266
  }
];
//----------------测试环境
// export const recipeList = [
//   {
//     name: "阿斯顿",
//     id: 15964
//   },
//   {
//     name: "aa",
//     id: 15949
//   },
//   {
//     name: "可乐鸡翅V2",
//     id: 15940
//   },
//   {
//     name: "发发发kjg",
//     id: 15965
//   }
// ];
// export const themeList = [
//   {
//     imgUrl: getOssOnlineImgFile("openBlind/topic1.png"),
//     themeId: 15
//   },
//   {
//     imgUrl: getOssOnlineImgFile("openBlind/topic2.png"),
//     themeId: 246
//   },
//   {
//     imgUrl: getOssOnlineImgFile("openBlind/topic3.png"),
//     themeId: 3
//   },
//   {
//     imgUrl: getOssOnlineImgFile("openBlind/topic4.png"),
//     themeId: 15
//   },
//   {
//     imgUrl: getOssOnlineImgFile("openBlind/topic5.png"),
//     themeId: 15
//   }
// ];



// WEBPACK FOOTER //
// ./src/views/roki/yearEndOpenBlindBox/data/index.js